import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRobot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRobot"><Path d="M9.5 14.5H14.5M12 4.5V2.5M2.5 8.5H1.5V11.5H2.5M21.5 8.5H22.5V11.5H21.5M9.5 10C9.5 10.5523 9.05228 11 8.5 11C7.94772 11 7.5 10.5523 7.5 10C7.5 9.44772 7.94772 9 8.5 9C9.05228 9 9.5 9.44772 9.5 10ZM16.5 10C16.5 10.5523 16.0523 11 15.5 11C14.9477 11 14.5 10.5523 14.5 10C14.5 9.44772 14.9477 9 15.5 9C16.0523 9 16.5 9.44772 16.5 10ZM3 4.5H21V16.5C21 18.1569 19.6569 19.5 18 19.5H6C4.34315 19.5 3 18.1569 3 16.5V4.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRobot;
